import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import SlugForm from '../components/SlugForm'

const Slug = ({ error, onSubmit, showError, fetching }) => (
  <React.Fragment>
    {showError && <p className={classNames(error && 'organaztion--alter-danger')}>{error}</p>}
    <SlugForm
      onSubmit={(values) => onSubmit(values.slug)}
      fetching={fetching}
    />
  </React.Fragment>
)

Slug.propTypes = {
  showError: PropTypes.bool.isRequired,
  error: PropTypes.node,
  fetching: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
}

export default Slug
